/* global Parse */

function geocode(address) {
  return fetch(`/api/geocode?address=${encodeURIComponent(address)}`, {
    accept: 'application/json',
  }).then(checkStatus)
    .then(parseJSON);
}

function nearestNeighbor_v4(clientLat, clientLon, eventNumber) {
  const currentUser = Parse.User.current();
  const username = currentUser.get('username');
  const objectId = currentUser.id;
  const parseKey = currentUser.get('EscaypeKeys').get('accessKey');
  const url = encodeURIComponent(currentUser.get('EscaypeKeys').get('url'));

  return fetch(`/api/nearestNeighbor_v4?url=${url}&clientLat=${clientLat}&clientLon=${clientLon}&eventNumber=${eventNumber}&username=${username}&objectId=${objectId}&parseKey=${parseKey}`, {
    accept: 'application/json',
  }).then(checkStatus)
    .then(parseJSON);
}

function nearestNeighborMoon_v4(clientLat, clientLon, eventNumber) {
  const currentUser = Parse.User.current();
  const username = currentUser.get('username');
  const objectId = currentUser.id;
  const parseKey = currentUser.get('EscaypeKeys').get('accessKey');
  const url = encodeURI(currentUser.get('EscaypeKeys').get('urlMoon'));

  return fetch(`/api/nearestNeighborMoon_v4?url=${url}&clientLat=${clientLat}&clientLon=${clientLon}&eventNumber=${eventNumber}&username=${username}&objectId=${objectId}&parseKey=${parseKey}`, {
    accept: 'application/json',
  }).then(checkStatus)
    .then(parseJSON);
}

function getHeatmapData_v4(eventNumber) {
  const currentUser = Parse.User.current();
  const username = currentUser.get('username');
  const objectId = currentUser.id;
  const parseKey = currentUser.get('EscaypeKeys').get('accessKey');
  const url = encodeURIComponent(currentUser.get('EscaypeKeys').get('urlHeatmap'));

  return fetch(`/api/getHeatmapData_v4?url=${url}&eventNumber=${eventNumber}&username=${username}&objectId=${objectId}&parseKey=${parseKey}`, {
    accept: 'application/json',
  }).then(checkStatus)
    .then(parseJSON);
}

function getdburi() {
  return fetch('/api/getdburi',{
    accept: 'application/json',
  }).then(checkStatus)
    .then(parseJSON);
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    const error = new Error(`HTTP Error ${response.statusText}`);
    error.status = response.statusText;
    error.response = response;
    console.error(error); // eslint-disable-line no-console
    throw error;
  }
}

function parseJSON(response) {
  return response.json();
}

const Client = {
  geocode: geocode,
  nearestNeighbor_v4: nearestNeighbor_v4,
  nearestNeighborMoon_v4: nearestNeighborMoon_v4,
  getHeatmapData_v4: getHeatmapData_v4,
  getdburi: getdburi
};
export default Client;
